/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { InboundDocumentFolder } from './InboundDocumentFolder';
import {
    InboundDocumentFolderFromJSON,
    InboundDocumentFolderFromJSONTyped,
    InboundDocumentFolderToJSON,
    InboundDocumentFolderToJSONTyped,
} from './InboundDocumentFolder';
import type { InboundDocumentWorkStatus } from './InboundDocumentWorkStatus';
import {
    InboundDocumentWorkStatusFromJSON,
    InboundDocumentWorkStatusFromJSONTyped,
    InboundDocumentWorkStatusToJSON,
    InboundDocumentWorkStatusToJSONTyped,
} from './InboundDocumentWorkStatus';

/**
 * 
 * @export
 * @interface InboundDocumentUpdateRequest
 */
export interface InboundDocumentUpdateRequest {
    /**
     * 
     */
    expected_date_modified: Date;
    /**
     * 
     */
    folder?: InboundDocumentFolder;
    /**
     * 
     */
    work_status?: InboundDocumentWorkStatus;
    /**
     * 
     */
    is_read?: boolean;
    /**
     * 
     */
    facility_ids?: Array<string>;
    /**
     * 
     */
    lead_id?: string;
}



/**
 * Check if a given object implements the InboundDocumentUpdateRequest interface.
 */
export function instanceOfInboundDocumentUpdateRequest(value: object): value is InboundDocumentUpdateRequest {
    if (!('expected_date_modified' in value) || value['expected_date_modified'] === undefined) return false;
    return true;
}

export function InboundDocumentUpdateRequestFromJSON(json: any): InboundDocumentUpdateRequest {
    return InboundDocumentUpdateRequestFromJSONTyped(json, false);
}

export function InboundDocumentUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_date_modified': (json['expected_date_modified'] == null ? json['expected_date_modified'] : parseDateTime(json['expected_date_modified'])),
        'folder': json['folder'] == null ? undefined : InboundDocumentFolderFromJSON(json['folder']),
        'work_status': json['work_status'] == null ? undefined : InboundDocumentWorkStatusFromJSON(json['work_status']),
        'is_read': json['is_read'] == null ? undefined : json['is_read'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
    };
}

export function InboundDocumentUpdateRequestToJSON(json: any): InboundDocumentUpdateRequest {
    return InboundDocumentUpdateRequestToJSONTyped(json, false);
}

export function InboundDocumentUpdateRequestToJSONTyped(value?: InboundDocumentUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_date_modified': value['expected_date_modified'] == null ? value['expected_date_modified'] : serializeDateTime(value['expected_date_modified']),
        'folder': InboundDocumentFolderToJSON(value['folder']),
        'work_status': InboundDocumentWorkStatusToJSON(value['work_status']),
        'is_read': value['is_read'],
        'facility_ids': value['facility_ids'],
        'lead_id': value['lead_id'],
    };
}

